"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bullet = void 0;
var React = require("react");
var Icons_1 = require("../../../_Core/Icons");
var Icons_2 = require("../../../Icons");
var Bullet_styles_1 = require("./Bullet.styles");
var Bullet = function (_a) {
    var BulletState = _a.BulletState, IsCurrent = _a.IsCurrent;
    var icon = BulletState === "Warning" ? Icons_1.Icons.Cancelled : Icons_1.Icons.TickCircle;
    var isCurrent = BulletState === "Warning" ? false : IsCurrent;
    var showIcon = BulletState === "Warning" || (!IsCurrent && BulletState === "Complete");
    return (React.createElement(Bullet_styles_1.BulletSpan, { IsCurrent: isCurrent, StepState: BulletState },
        React.createElement(Bullet_styles_1.BulletIconSpan, { Show: showIcon },
            React.createElement(Icons_2.Icon, { Icon: icon }))));
};
exports.Bullet = Bullet;
